module.exports = __webpack_public_path__ + "img/Copyright_pic01.533afe4f.jpg";